var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "down-arrow",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 302",
    style: {
      enableBackground: "new 0 0 500 302"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M453.4,0h8.6c2.4,0.7,4.8,1.3,7.2,2.3c10.5,4.3,17.2,13.2,24.2,21.5c3.3,3.9,4.5,9.7,6.7,14.7v8.9c-0.2,0.1-0.5,0.2-0.5,0.4 c-0.6,8.2-5,14.5-10.3,20.1c-72.3,74.7-144.7,149.3-217.1,224c-0.9,1-1.9,1.8-2.9,2.7c-4.4,4-9.7,5.8-15.2,7.4h-8.6 c-0.2-0.2-0.5-0.6-0.7-0.7c-7.4-1.2-14.2-4.7-19.4-10.2C153.9,217.6,82.6,144,11.3,70.4c-2.9-3-5.3-6.5-7.1-10.3 c-1.9-4-2.9-8.5-4.2-12.7v-9.6c0.2-0.2,0.6-0.5,0.7-0.8c0.4-6.8,3.2-12.5,7-17.9c13.8-19.9,42.6-21.6,59-4.7 c59.6,61.5,119.2,123,178.8,184.5c1,1,1.9,2.2,3.4,3.9c0.8-1.2,1.7-2.4,2.6-3.5C312.2,136.5,372.9,73.8,433.7,11 c1-1,2.1-1.9,3.2-2.9C441.6,3.7,447.5,1.8,453.4,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.a9b6623581ec0f1067075737291b7419.svg";
export { ForwardRef as ReactComponent };